import Pushy from '@cmyee/pushy/js/pushy.min.js';

window.Pushy = Pushy;

jQuery(document).ready(function ($) {
    "use strict";

    /* Owl Slider For Featured Section
    ======================================================*/
    if ($('#cp-time-slider').length) {
        $('#cp-time-slider').owlCarousel({
            loop: true,
            dots: false,
            nav: false,
            navText: '',
            items: 4,
            smartSpeed: 500,
            margin: 0,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                },
                1199: {
                    items: 4,
                }
            }
        });
    }


    closePushy();

    $(window).on("resize", function () {
        closePushy();
    });

    function closePushy() {
        if ($(window).width() >= 767) {
            $('body').removeClass("pushy-open-right");
        }
    }
});


/* Event Counter
======================================================*/
if ($(".defaultCountdown-event-1").length) {
    var austDay = new Date();
    austDay = new Date(2022, 10 - 10, 19);
    jQuery('.defaultCountdown-event-1').countdown({
        labels: ['Years', 'Months', 'Weeks', 'Days', 'Hrs', 'Min', 'Sec'],
        until: austDay
    });
    jQuery('#year').text(austDay.getFullYear());
}

$(window).on("load",function(){
    $("#preloader").fadeOut(250);
});

